var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCatalog = function SvgCatalog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.917 2.417a.5.5 0 1 0 0 1h1.587l1.828 9.62a.5.5 0 0 0 .491.407h8.932a.5.5 0 0 0 .492-.41l1.329-7.244a.5.5 0 0 0-.492-.59H5.86l-.452-2.377a.5.5 0 0 0-.491-.406H2.917Zm4.32 10.027L6.051 6.2h10.433l-1.146 6.244h-8.1Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.917 2.417a.5.5 0 1 0 0 1h1.587l1.828 9.62a.5.5 0 0 0 .491.407h8.932a.5.5 0 0 0 .492-.41l1.329-7.244a.5.5 0 0 0-.492-.59H5.86l-.452-2.377a.5.5 0 0 0-.491-.406H2.917Zm4.32 10.027L6.051 6.2h10.433l-1.146 6.244h-8.1Z",
    fill: "#747F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.063 15.833a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0Zm1.333-.333a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667Z",
    fill: "#818C96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.063 15.833a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0Zm1.333-.333a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667Z",
    fill: "#747F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.052 15.833a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0Zm1.333-.333a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667Z",
    fill: "#818C96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.052 15.833a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0Zm1.333-.333a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667Z",
    fill: "#747F88"
  })));
};

export default SvgCatalog;